//Our Team Slider
let mainSlider = document.getElementsByClassName('our-team__slider');
let body = document.getElementsByTagName('body');



if (mainSlider.length > 0) {
  let mainSlides = mainSlider[0].getElementsByClassName('swiper-slide');
  let secondSlider = document.getElementsByClassName('our-team__modal-container');
  let secondSliderClose = document.getElementsByClassName('closeTeamPopup');

  const closeModal = function() {
    secondSlider[0].style.opacity = '0';
    secondSlider[0].style.zIndex = '-1';
    let div = document.getElementsByClassName('our-team__overlay');
    div[0] && div[0].remove();
  }

  for (let i = 0; i < mainSlides.length; i++) {
      mainSlides[i].addEventListener('click', function() {
          secondSlider[0].style.opacity = '1';
          secondSlider[0].style.zIndex = '10';
          var $root = $('html, body');
          $root.animate({
            scrollTop: $(mainSlider[0]).offset().top - 250
            }, 500);
          let div = document.createElement('div');
          div.classList.add('our-team__overlay');
          document.body.appendChild(div)
          body[0].style.position = 'relative';
      })
      secondSliderClose[i].addEventListener('click', function() {
          closeModal();
      })

      window.addEventListener('click', function(e) {
      if (!e.path.some(x => x.className && x.className.includes(['our-team__modal-container']))) {
        closeModal();
      }
      }, true)

  }
}
